import { motion } from "framer-motion";
import { ArrowRight, MessageCircle } from "lucide-react";
import { SITE } from "@/config/site";
import { scrollToFormField } from "@/lib/scroll";

export const FinalCta = () => (
  <section data-testid="final-cta-section" className="bg-brand-yellow py-24 sm:py-32 relative overflow-hidden">
    <div
      aria-hidden
      className="absolute -right-24 -top-24 w-96 h-96 rounded-full border-[3rem] border-brand-ink/5"
    />
    <div
      aria-hidden
      className="absolute -left-32 -bottom-32 w-[28rem] h-[28rem] rounded-full border-[4rem] border-brand-ink/5"
    />
    <div className="relative max-w-5xl mx-auto px-5 sm:px-8 text-center">
      <motion.h2
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
        className="font-display font-black tracking-tight text-brand-ink text-4xl sm:text-5xl lg:text-6xl leading-[1.05]"
      >
        ¿Necesitas más espacio?
        <span className="block mt-2">Ya tienes OtraRoom.</span>
      </motion.h2>
      <motion.p
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8, delay: 0.2 }}
        className="mt-6 text-base sm:text-lg text-brand-ink/70 font-medium"
      >
        Prerreserva antes de la apertura: prioridad para elegir tamaño y descuento en tu primer mes. Sin compromiso.
      </motion.p>
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8, delay: 0.35 }}
        className="mt-10 flex flex-col sm:flex-row justify-center gap-4"
      >
        <motion.button
          data-testid="final-cta-sizes-button"
          onClick={() => scrollToFormField()}
          whileHover={{ scale: 1.04 }}
          whileTap={{ scale: 0.97 }}
          className="inline-flex items-center justify-center gap-2 bg-brand-ink text-white font-display font-extrabold tracking-wide px-9 py-4 rounded-full hover:bg-brand-inkcard transition-colors duration-200 shadow-[0_14px_40px_rgba(18,19,22,0.35)]"
        >
          PRERRESERVAR MI TRASTERO
          <ArrowRight size={18} strokeWidth={2.6} />
        </motion.button>
        <motion.a
          data-testid="final-cta-whatsapp-button"
          href={SITE.whatsappUrl}
          target="_blank"
          rel="noopener noreferrer"
          whileHover={{ scale: 1.04 }}
          whileTap={{ scale: 0.97 }}
          className="inline-flex items-center justify-center gap-2 border-[3px] border-brand-ink text-brand-ink font-display font-extrabold tracking-wide px-9 py-4 rounded-full hover:bg-brand-ink hover:text-brand-yellow transition-[background-color,color] duration-200"
        >
          <MessageCircle size={18} />
          HABLAR POR WHATSAPP
        </motion.a>
      </motion.div>
    </div>
  </section>
);
